module.exports = __webpack_public_path__ + "res/dummy_reels_sp2.97e3340b07af945b8140d98542a11afe.jpg";